import { axiosInstance } from "../../axios/axiosInstance";
import { ADMIN_API_URL, getDefaultHeaders } from "../../config";

const authHeaders = () => {
  const authToken = localStorage.getItem("authToken");
  return {
    ...getDefaultHeaders(),
    Authorization: `Bearer ${authToken}`,
  };
};

export const getTeams = (dateRange = {}) =>
  axiosInstance.get(`${ADMIN_API_URL}/team/get-all`, {
    headers: authHeaders(),
    params: dateRange,
  });

export const createTeamRequest = (teamData) =>
  axiosInstance.post(`${ADMIN_API_URL}/team/create`, teamData, {
    headers: authHeaders(),
  });

export const updateTeamRequest = (teamId, teamData) =>
  axiosInstance.put(`${ADMIN_API_URL}/team/update/${teamId}`, teamData, {
    headers: authHeaders(),
  });

export const removeTeam = (teamId) =>
  axiosInstance.delete(`${ADMIN_API_URL}/team/delete/${teamId}`, {
    headers: authHeaders(),
  });
